export default __webpack_public_path__ + "static/media/pv_grid_dir_big_2.9805df5a.png";